module.exports = __webpack_public_path__ + "img/aim.5b3f5619.png";